import { render, staticRenderFns } from "./ItemListProfileMarketLayout.vue?vue&type=template&id=04dc78a1&scoped=true"
import script from "./ItemListProfileMarketLayout.vue?vue&type=script&lang=js"
export * from "./ItemListProfileMarketLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04dc78a1",
  null
  
)

export default component.exports